export default [
  {
    path: '/organizationunder',
    name: 'organizationunder',
    component: () => import('@/views/system/OrganizationUnder.vue'),
    meta: {},
  },
];
